import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Trees, Mail, Lock } from 'lucide-react';
import api from '../../utils/api';
import { toast } from 'sonner';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = isRegister ? '/auth/register' : '/auth/login';
      const response = await api.post(endpoint, formData);
      
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_name', response.data.name);
      
      toast.success(`Welcome ${response.data.name}!`);
      navigate('/manage/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#F9F8F6' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-6">
            <Trees size={40} style={{ color: '#1A3C34' }} />
            <span
              className="text-3xl font-bold"
              style={{ fontFamily: 'Playfair Display, serif', color: '#1A3C34' }}
            >
              The BaghHome
            </span>
          </div>
          <h1
            className="text-3xl font-bold mb-2"
            style={{ fontFamily: 'Playfair Display, serif', color: '#1A3C34' }}
            data-testid="admin-login-title"
          >
            {isRegister ? 'Create Admin Account' : 'Admin Login'}
          </h1>
          <p style={{ color: '#64748B' }}>Access the dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-3xl p-8 shadow-sm" data-testid="admin-login-form">
          {isRegister && (
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2" style={{ color: '#1A202C' }}>
                Name
              </label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full h-12 px-4 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#1A3C34]/20 transition-all"
                data-testid="admin-name-input"
              />
            </div>
          )}

          <div className="mb-6">
            <label className="block text-sm font-medium mb-2" style={{ color: '#1A202C' }}>
              <Mail size={16} className="inline mr-2" />Email
            </label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full h-12 px-4 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#1A3C34]/20 transition-all"
              data-testid="admin-email-input"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-2" style={{ color: '#1A202C' }}>
              <Lock size={16} className="inline mr-2" />Password
            </label>
            <input
              type="password"
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full h-12 px-4 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#1A3C34]/20 transition-all"
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="admin-login-button"
          >
            {loading ? 'Please wait...' : (isRegister ? 'Register' : 'Login')}
          </button>

          <p className="text-center mt-6" style={{ color: '#64748B' }}>
            {isRegister ? 'Already have an account?' : "Don't have an account?"}{' '}
            <button
              type="button"
              onClick={() => setIsRegister(!isRegister)}
              className="font-medium hover:underline"
              style={{ color: '#1A3C34' }}
              data-testid="toggle-register"
            >
              {isRegister ? 'Login' : 'Register'}
            </button>
          </p>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;